import { memo } from "react";

import src from "../img/events/znv-banner.jpg";

function ZnvHeader() {
  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <a
        href="https://www.zukunftnahverkehr.de/iaa/"
        rel="noreferrer"
        target="_blank"
      >
        <img alt="Zukunft Nahverkehr" src={src} width="100%" />
      </a>
    </div>
  );
}

export default memo(ZnvHeader);
